import { Component, EventEmitter, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, delay, distinctUntilChanged, filter } from 'rxjs';
import { MediaService } from '../../../api/services';
import {
  CloudSearchResponse,
  CloudSearchResponseItem,
} from '../../../api/models';
import { PaginatorState } from 'primeng/paginator';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-cloud-image-picker',
  templateUrl: './cloud-image-picker.component.html',
  styleUrl: './cloud-image-picker.component.scss',
})
export class CloudImagePickerComponent {
  keyword = new FormControl('');
  results?: CloudSearchResponse;
  limit = 12;
  skip = 0;
  loading = false;
  selectedImages: CloudSearchResponseItem[] = [];

  constructor(
    private mediaService: MediaService,
    public ref: DynamicDialogRef
  ) {}

  ngOnInit() {
    this.keyword.valueChanges
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        filter((x) => x!.length > 1)
      )
      .subscribe((k) => {
        this.search();
      });
  }

  search() {
    this.loading = true;
    this.mediaService
      .mediaControllerCloudSearch({
        keyword: this.keyword.value!,
        limit: this.limit,
        skip: this.skip,
      })
      .pipe(delay(1000))
      .subscribe({
        next: (data) => {
          this.loading = false;
          this.results = data.data;
        },
      });
  }

  // selectImage(e: Event, pic: CloudSearchResponseItem) {
  //   e.preventDefault();
  //   this.ref.close({ images: pic });
  // }

  selectImage(e: Event, pic: CloudSearchResponseItem) {
    e.preventDefault();
  
    const alreadySelected = this.selectedImages.find(img => img.id === pic.id);
    if (alreadySelected) {
      this.selectedImages = this.selectedImages.filter(img => img.id !== pic.id);
    } else {
      this.selectedImages.push(pic);
    }
  }

  confirmSelection() {
    this.ref.close({ images: this.selectedImages });
  }

  isSelected(pic: CloudSearchResponseItem): boolean {
    return !!this.selectedImages.find(img => img.id === pic.id);
  }

  onPageChange(e: PaginatorState) {
    this.skip = e.page! * this.limit;
    this.search();
  }
}
